import axios from "axios";
import React, { useState, useEffect } from "react";

interface UserDetails {
  role: string;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone_number: string;
  password: string;
}

function Profile() {
  const api = process.env.REACT_APP_API_URL as string;
  const [error, setError] = useState<string>("");
  const [userData, setUserData] = useState<UserDetails | null>(null);

  // Fetch user details on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${api}/auth/admin/1`);
        setUserData(response.data.data[0]);
        console.log("Fetched user data:", response.data.data[0]);
      } catch (error: any) {
        setError("Unable to fetch user details.");
        console.error("Fetch failed:", error);
      }
    };

    fetchUserData();
  }, [api]);

  return (
    <div className="w-[100%] h-auto p-8">
      <div className="w-[100%] bg-[#fff] rounded-xl">
        <div className="w-[100%]">
          <h1 className="text-[20px] font-[700] text-gray-800 py-[16px] px-[24px]">
            Update Profile
          </h1>
        </div>
        <div className="wi-[100%] border-b-[1px] border-[#c0bebe] border-dashed"></div>
        <div className="w-[100%] py-[16px] px-[24px]">
          <div className="w-[100%] border-[1px] border-[#000]">
            <div className="w-full flex flex-wrap gap-4 p-4">
              <div className="w-full sm:w-[48%] lg:w-[32%]">
                <label className="block text-[16px] font-medium text-[#555454] mb-1">
                  UserName
                </label>
                <input
                  type="text"
                  value={userData?.username || ""}
                  readOnly
                  className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] font-bold text-[#555454]"
                />
              </div>

              <div className="w-full sm:w-[48%] lg:w-[32%]">
                <label className="block text-[16px] font-medium text-[#555454] mb-1">
                  First Name
                </label>
                <input
                  type="text"
                  value={userData?.first_name || ""}
                  readOnly
                  className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] font-bold text-[#555454]"
                />
              </div>

              <div className="w-full sm:w-[48%] lg:w-[32%]">
                <label className="block text-[16px] font-medium text-[#555454] mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  value={userData?.last_name || ""}
                  readOnly
                  className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] font-bold text-[#555454]"
                />
              </div>

              <div className="w-full sm:w-[48%] lg:w-[32%]">
                <label className="block text-[16px] font-medium text-[#555454] mb-1">
                  Email
                </label>
                <input
                  type="email"
                  value={userData?.email || ""}
                  readOnly
                  className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] font-bold text-[#555454]"
                />
              </div>

              <div className="w-full sm:w-[48%] lg:w-[32%]">
                <label className="block text-[16px] font-medium text-[#555454] mb-1">
                  Phone Number
                </label>
                <input
                  type="tel"
                  value={userData?.phone_number || ""}
                  readOnly
                  className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] font-bold text-[#555454]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {error && <p className="text-red-500 mt-4">{error}</p>}
    </div>
  );
}

export default Profile;
